import loadingState from '@/states/loadingState';
import { useCallback } from 'react';
import { useRecoilState } from 'recoil';

/**
 * loadingState設定用フック
 * @param url 実行するAPIのURL
 * @returns startLoading 開始
 * @returns finishLoading 終了
 */
const useSetLoading = () => {
  const [loading, setIsLoading] = useRecoilState(loadingState);
  const startLoading = useCallback((url: string) => {
    setIsLoading(prev => prev.concat([url]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const finishLoading = useCallback((url: string) => {
    setIsLoading(prev => prev.filter(str => str !== url));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * ローディング状態を取得する。
   * @param keys 特定のローディング状態を取得する場合に使用する
   * @returns ローディング状態が存在する場合は、trueを返却する。それ以外は、falseを返却する。
   */
  const isLoading = useCallback((keys?: string | string[]): boolean => {
    const state = loading;
    if (state.length === 0) {
      return false;
    }
    if (typeof keys === 'string') {
      return state.includes(keys);
    }
    if (Array.isArray(keys)) {
      return state.some(e => keys.includes(e));
    }
    return true;
  }, [loading]);
  return {
    isLoading,
    startLoading,
    finishLoading
  };
};
export default useSetLoading;